import {
  permissionNamesSelector,
  permissionsSelector,
} from "appredux/selectors";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useMatches } from "react-router";

const useCheckPermissionPage = () => {
  // raw dipakai KHUSUS untuk deteksi "inits belum termuat" (null/undefined),
  // supaya route tidak diblokir sementara data belum siap.
  const permissions = useSelector(permissionsSelector);
  const names = useSelector(permissionNamesSelector);
  const matches = useMatches();

  const specialRoute = useMemo(() => ["/settings"], []);

  const handleSpecialRoute = useCallback(
    (name) => {
      if (name === "/settings") {
        return names.some((perm) => perm.startsWith("setting_"));
      }
      return true;
    },
    [names]
  );

  const isGetPermission = useMemo(() => {
    if (!permissions) return true;
    if (specialRoute.includes(matches[matches.length - 1]?.pathname)) {
      return handleSpecialRoute(matches[matches.length - 1]?.pathname);
    }

    const name = matches[matches.length - 1]?.handle?.permission || null;

    if (!name) {
      return true; // yg tidak ada permission di route, maka boleh akses, jika ada permission di route, maka dicek
    }

    return names.includes(name);
  }, [matches, permissions, names, handleSpecialRoute, specialRoute]);

  return {
    isGetPermission,
  };
};

export default useCheckPermissionPage;
